import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/more.png'
import _imports_1 from '../../static/images/ga.png'


const _withScopeId = n => (_pushScopeId("data-v-ce23d60e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "you-links" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "友情链接", -1))
const _hoisted_3 = ["src", "title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "foot" }
const _hoisted_7 = { class: "foot-nav" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { class: "foot-lian" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "联系方式", -1))
const _hoisted_17 = { class: "p" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "关注我们", -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "扫码关注", -1))
const _hoisted_21 = { class: "foot-btm" }
const _hoisted_22 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51180202512000",
  target: "_blank",
  class: "l"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("川公网安备 51180202512000号")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cdsile.com/",
  target: "_blank"
}, "成都网站建设:思乐科技", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_swiper, {
        class: "swp-link",
        loop: _ctx.swiperLink.loop,
        slidesPerView: _ctx.swiperLink.slidesPerView,
        breakpoints: _ctx.swiperLink.breakpoints,
        onSwiper: _ctx.setControlledSwiper
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.image,
                  alt: "",
                  class: "icon gd",
                  title: item.title
                }, null, 8, _hoisted_3)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["loop", "slidesPerView", "breakpoints", "onSwiper"]),
      _createElementVNode("div", {
        class: "mo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.linkNext && _ctx.linkNext(...args)))
      }, _hoisted_5)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FnavList, (item) => {
            return (_openBlock(), _createElementBlock("dl", {
              key: item.id
            }, [
              (item.id == 13)
                ? (_openBlock(), _createElementBlock("dt", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: { path: item.route, query: {id: item.sonlist[0].id} }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (item.id == 20)
                  ? (_openBlock(), _createElementBlock("dt", _hoisted_9, [
                      _createElementVNode("a", {
                        href: item.text,
                        target: "_blank"
                      }, _toDisplayString(item.name), 9, _hoisted_10)
                    ]))
                  : (_openBlock(), _createElementBlock("dt", _hoisted_11, [
                      _createVNode(_component_router_link, {
                        to: item.route
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])),
              (item.id == 8)
                ? (_openBlock(), _createElementBlock("dd", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        to: { path: '/product-detail/' + child.id },
                        class: "a",
                        key: child.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(child.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ]))
                : (item.id == 13)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: { path: item.route, query: {id: child.id} },
                          class: "a",
                          key: child.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("dd", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sonlist, (child) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          to: child.route,
                          class: "a",
                          key: child.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(child.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, "电话：" + _toDisplayString(_ctx.mobile.text), 1),
            _createElementVNode("p", null, "地址：" + _toDisplayString(_ctx.address.text), 1),
            _createElementVNode("p", null, "邮箱：" + _toDisplayString(_ctx.email.text), 1)
          ]),
          _hoisted_18,
          _createElementVNode("img", {
            src: _ctx.erweima.image,
            alt: "",
            class: "ma"
          }, null, 8, _hoisted_19),
          _hoisted_20
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.banquan) + " 备案号： ", 1),
          _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.beian), 1),
          _hoisted_23
        ]),
        _hoisted_24
      ])
    ])
  ], 64))
}